module.exports = __webpack_public_path__ + "media/managing_your_money/private-b80725d6.png";